// Entry point for the build script in your package.json

import Rails from "@rails/ujs"
Rails.start()

import './add_jquery'
import "@fortawesome/fontawesome-free/js/all";
import 'chosen-js'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-datepicker/js/bootstrap-datepicker'
import 'cocoon-js'
import 'summernote'

import { I18n } from "i18n-js"
import translations from "./locales.json";
I18n.defaultLocale = "da"
I18n.locale = "da"

window.I18n = I18n

$.fn.datepicker.dates.da = {
    days: ["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],
    daysShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],
    daysMin:["Sø","Ma","Ti","On","To","Fr","Lø"],
    months:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],
    monthsShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],
    today:"I Dag",
    weekStart:1,
    clear:"Nulstil",
    format:"dd/mm/yyyy",
    monthsTitle:"Måneder"
};

$('.datepicker').datepicker({
    language: 'da'
});


import './applications.coffee'
import './databases.coffee'
import './logs.coffee'
import './search.coffee'
import './support.coffee'

import './application/basic_info'
import './application/study_info'
import './application/delivery_info'

import './transitions/accept_formalities'
import './transitions/accept_content'
import './transitions/applicant_accepts'
import './transitions/steering_accepts'
import './transitions/rejected_extract'
import './transitions/datamanager_accepts'
import './manage_users/manage_users.coffee'
import './manage_users/new_user'
